import ztComponent from './ztDataTable.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
